import { gql } from '../generated';

gql(`
  fragment MarketplaceEligibility on MarketplaceEligibility {
    aptc
    csr
    hardshipExemption
    isMedicaidChip
  }
`);

gql(`
  fragment PXDependent on PublicHealthExplorerDependentOld {
    age
    relation
    sex
    isSmoker
  }
`);

gql(`
  fragment PXDep on PublicHealthExplorerDependent {
    id
    age
    relation
    sex
    isSmoker
    lawfulPresence
  }
`);

gql(`
  fragment SessionFields on PublicHealthExplorerData {
    id
    email
    zipcode
    countyfips
    coverageYear
    possibleCoverageYears
    state
    income
    providerPlanID
    pathway
    email
    exchangeType
    financialPreference
    plannedUsage
    drugsWanted {
      rxcui
      name
    }
    providersWanted {
      npi
      name
    }
    dependents {
      ...PXDependent
    }
    deps {
      ...PXDep
    }
  }
`);

export const UPSERT_SESSION = gql(`
  mutation UpsertSession($input: PublicHealthExplorerDataInput!) {
    upsertPublicHealthExplorerData(input: $input) {
      ...SessionFields
    }
  }
`);

export const GET_SESSION = gql(`
  query PublicHealthSession($id: ID!) {
    getPublicHealthExplorerData(id: $id) {
      ...SessionFields
    }
  }
`);

export const REPLACE_DEPENDENTS = gql(`
  mutation ReplacePublicDependents($input: UpsertPublicHealthExplorerDependentsInput!) {
    replacePublicHealthExplorerDependents(input: $input) {
      ...PXDep
    }
  }
`);

export const GET_LAWFUL_PRESENCE_CONFIG = gql(`
  query PublicLawfulPresenceConfig {
    reference {
      health {
        askExplorerLawfulPresenceGA
      }
    }
  }
`);

export const GET_OPEN_ENROLLMENT_DATES = gql(`
  query PublicOpenEnrollmentDates {
    reference {
      health {
        openEnrollmentDates {
          possibleCoverageYears
          preferredCoverageYear
        }
      }
    }
  }
`);
